import { useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const AdZone = ({ }) => {

    return (
        <></>
        // <div className="card card-body">
        //     {/* <Link to="https://docs.google.com/spreadsheets/d/1GqwBojuqY_nevYkXA1T1yPxlWrDvy63kZgrY8wPP368" target="_blank" style={{ textDecoration: 'none' }}>
        //         <img src="https://cdn.cotik.app/QqIDSkOZ7pomPb3GZpMGaOscPj5Y0bkx.png" alt="Adzone" style={{ width: '100%' }} />
        //     </Link> */}
        // </div>
    );
};

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AdZone);
